/* =========================================================================
   LP Base — JavaScript das seções lp-*
   1) Escolha de variante (tamanho/versão) nos blocos de compra
      - atualiza o preço, o preço "de", o Pix e o botão (Esgotado)
      - sincroniza Hero e Oferta (escolheu num, muda no outro)
   2) Galeria: clicar na miniatura troca a imagem grande
   3) Barra fixa: aparece no celular quando o botão do Hero sai da tela
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- Formatação de dinheiro (centavos -> R$ 149,90) ---------- */
  function formatar(centavos, moeda) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: moeda || 'BRL' }).format(centavos / 100);
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  /* ---------- 1) Variantes ---------- */
  var formularios = Array.prototype.slice.call(document.querySelectorAll('[data-lp-compra]'));

  function lerVariantes(caixa) {
    var json = caixa.querySelector('script[data-lp-variantes]');
    if (!json) return [];
    try { return JSON.parse(json.textContent); } catch (e) { return []; }
  }

  function opcoesEscolhidas(caixa) {
    var grupos = caixa.querySelectorAll('[data-lp-opcao]');
    return Array.prototype.map.call(grupos, function (grupo) {
      var marcado = grupo.querySelector('input:checked');
      return marcado ? marcado.value : null;
    });
  }

  function acharVariante(variantes, opcoes) {
    for (var i = 0; i < variantes.length; i++) {
      var v = variantes[i];
      var ok = opcoes.every(function (valor, idx) { return v.options[idx] === valor; });
      if (ok) return v;
    }
    return null;
  }

  function atualizar(caixa, sincronizar) {
    var variantes = lerVariantes(caixa);
    if (!variantes.length) return;
    var moeda = caixa.getAttribute('data-moeda');
    var pix = parseFloat(caixa.getAttribute('data-pix') || '0');
    var variante = acharVariante(variantes, opcoesEscolhidas(caixa));

    var inputId = caixa.querySelector('input[name="id"]');
    var botao = caixa.querySelector('[data-lp-botao]');
    var txtBotao = caixa.querySelector('[data-lp-botao-texto]');
    var elPor = caixa.querySelector('[data-lp-por]');
    var elDe = caixa.querySelector('[data-lp-de]');
    var elPix = caixa.querySelector('[data-lp-pix-valor]');
    var linhaPix = caixa.querySelector('[data-lp-pix]');

    if (!variante) {
      if (botao) botao.disabled = true;
      if (txtBotao) txtBotao.textContent = caixa.getAttribute('data-txt-indisponivel');
      return;
    }

    if (inputId) inputId.value = variante.id;
    if (elPor) elPor.textContent = formatar(variante.price, moeda);
    if (elDe) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        elDe.textContent = formatar(variante.compare_at_price, moeda);
        elDe.hidden = false;
      } else {
        elDe.hidden = true;
      }
    }
    if (elPix && pix > 0) elPix.textContent = formatar(Math.floor(variante.price * (100 - pix) / 100), moeda);
    if (linhaPix) linhaPix.hidden = !(pix > 0);

    trocarImagem(caixa.getAttribute('data-produto'), variante);

    if (botao) botao.disabled = !variante.available;
    if (txtBotao) {
      txtBotao.textContent = variante.available
        ? caixa.getAttribute('data-txt-comprar')
        : caixa.getAttribute('data-txt-esgotado');
    }

    /* Mantém Hero e Oferta com a mesma escolha */
    if (sincronizar) {
      formularios.forEach(function (outra) {
        if (outra === caixa || outra.getAttribute('data-produto') !== caixa.getAttribute('data-produto')) return;
        variante.options.forEach(function (valor, idx) {
          var grupo = outra.querySelectorAll('[data-lp-opcao]')[idx];
          if (!grupo) return;
          Array.prototype.forEach.call(grupo.querySelectorAll('input'), function (inp) {
            inp.checked = inp.value === valor;
          });
        });
        atualizar(outra, false);
      });
    }
  }

  /* Troca a foto do Hero e da Oferta pela foto da variante escolhida */
  function urlFoto(url, largura) {
    /* mantém os parâmetros da Shopify (ex.: ?v=123) e troca só a largura */
    var partes = url.split('?');
    var params = (partes[1] || '').split('&').filter(function (p) { return p && p.indexOf('width=') !== 0; });
    params.push('width=' + largura);
    return partes[0] + '?' + params.join('&');
  }
  var fotoAtual = {};
  function trocarImagem(produtoId, variante) {
    if (!variante.image || fotoAtual[produtoId] === variante.image) return;
    fotoAtual[produtoId] = variante.image;
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-variante-img="' + produtoId + '"]'), function (caixaImg) {
      var img = caixaImg.querySelector('img');
      if (!img) {
        caixaImg.innerHTML = '';
        img = document.createElement('img');
        img.alt = '';
        caixaImg.appendChild(img);
      }
      img.loading = 'eager';
      img.removeAttribute('srcset'); /* usa a mesma URL pré-carregada = troca instantânea */
      img.src = urlFoto(variante.image, 1000);
    });
  }
  /* Pré-carrega as fotos das variantes depois que a página termina de abrir */
  window.addEventListener('load', function () {
    var vistas = {};
    formularios.forEach(function (caixa) {
      lerVariantes(caixa).forEach(function (v) {
        if (v.image && !vistas[v.image]) { vistas[v.image] = 1; new Image().src = urlFoto(v.image, 1000); }
      });
    });
  });

  formularios.forEach(function (caixa) {
    caixa.addEventListener('change', function (e) {
      if (e.target && e.target.closest('[data-lp-opcao]')) atualizar(caixa, true);
    });
  });

  /* ---------- 2) Galeria ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-lp-galeria]'), function (gal) {
    var slides = gal.querySelectorAll('.lp-galeria__slide');
    var minis = gal.querySelectorAll('.lp-galeria__mini button');
    Array.prototype.forEach.call(minis, function (btn, i) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(slides, function (s, j) { s.hidden = j !== i; });
        Array.prototype.forEach.call(minis, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- 3) Barra fixa ---------- */
  var barra = document.querySelector('[data-lp-barra]');
  if (barra) {
    document.body.classList.add('lp-barra-ativa');
    var alvo = document.querySelector('[data-lp-hero-botao]');
    var oferta = document.getElementById('lp-oferta');
    if ('IntersectionObserver' in window && alvo) {
      var heroVisivel = true;
      var ofertaVisivel = false;
      var aplicar = function () { barra.classList.toggle('is-visivel', !heroVisivel && !ofertaVisivel); };
      new IntersectionObserver(function (ent) { heroVisivel = ent[0].isIntersecting || ent[0].boundingClientRect.top > 0; aplicar(); }).observe(alvo);
      if (oferta) new IntersectionObserver(function (ent) { ofertaVisivel = ent[0].isIntersecting; aplicar(); }, { threshold: 0.25 }).observe(oferta);
    } else {
      barra.classList.add('is-visivel');
    }
  }
})();
